// Specializaion
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Profissional Documentos', true, 'professional')),
  route('create', '/create', Form, professionalMeta('Incluir Documentos', true, 'professional'))
]

export default subGroup('/documents', routes)



// WEBPACK FOOTER //
// ./src/app/professional/documents/routes.js